import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import usePromise from 'hooks/usePromise';
import { SourceMediaType } from 'redux/middleware/api/podcast-service';
import { loadWorkflowTemplates } from 'redux/modules/automation-cms';
import { showNotification } from 'redux/modules/notification';
import { goToCreate } from 'redux/modules/router';
import { Dispatch } from 'redux/types';
import { AspectRatioName } from 'types';

type LoadTemplateList = (
  aspectRatioName: AspectRatioName,
  sourceMediaType?: SourceMediaType,
) => void;

interface UseLoadTemplateList {
  loadTemplateList: LoadTemplateList;
}

const useLoadTemplateList = (): UseLoadTemplateList => {
  const dispatch = useDispatch<Dispatch>();

  const { setPromise } = usePromise<void>();

  const loadTemplateList: LoadTemplateList = useCallback(
    (aspectRatioName, sourceMediaType = 'audio') => {
      setPromise(
        dispatch(loadWorkflowTemplates(aspectRatioName, sourceMediaType)).catch(
          () => {
            dispatch(
              showNotification({
                message: 'Please try again or {{link}} so we can help',
                code: 'ER013',
                dismissAfterSec: 5,
                level: 'error',
                type: 'help',
                title: 'Error loading templates',
                actionLabel: 'contact us',
              }),
            );

            dispatch(goToCreate());
          },
        ),
      );
    },
    [dispatch, setPromise],
  );

  return {
    loadTemplateList,
  };
};

export default useLoadTemplateList;
